import { action, defineNotificationStream } from "../../define.js";
export const approvalRequestNotifications = defineNotificationStream({
    service: "approval",
    stream: "approval-request",
    description: "Audit trail of approval request changes (Content Inbox)",
    actions: {
        create: action("Emitted when an approval request is created"),
        recreate: action("Emitted when a withdrawn approval request is recreated"),
        approve: action("Emitted when an approval request is approved"),
        reject: action("Emitted when an approval request is rejected or withdrawn"),
        suspend: action("Emitted when an approval request is suspended"),
        revert_to_new: action("Emitted when an approval request is reverted to new"),
        lock: action("Emitted when an approval request is locked for review"),
        unlock: action("Emitted when an approval request lock is released"),
        update_contact_id: action("Emitted when the contact of an approval request changes"),
        unlink_lawyer: action("Emitted when the lawyer contact and name are removed from an approval request"),
        re_file: action("Emitted when an approval request is moved to another practice area and table"),
        update_content_output: action("Emitted when the content output of an approval request changes"),
        auto_approve: action("Emitted when an approval request is auto-approved"),
    },
});
export const APPROVAL_REQUEST_AUDIT_ACTIONS = Object.keys(approvalRequestNotifications.actions);
//# sourceMappingURL=approval-request.js.map